import image1 from "../../assets/images/Specialized Training.png";
import image2 from "../../assets/images/Automation Support.png";
import image3 from "../../assets/images/Process Engineering.png";
import image4 from "../../assets/images/Oil & Gas Drilling.png";
import image5 from "../../assets/images/Consultancy.png";
import image6 from "../../assets/images/Solar Panel Installations.png";

const ServicesData = [
  {
    id: 1,
    title: "Specialized Training",
    image: image1,
    text: "We offer specialized training services",
  },
  {
    id: 2,
    title: "Automation Support",
    image: image2,
    text: "We have you covered",
  },
  {
    id: 3,
    title: "Process Engineering",
    image: image3,
    text: "Allow us manage your production processes ",
  },
  {
    id: 4,
    title: "Oil & Gas Drilling",
    image: image4,
    text: "We specialize in both onshore and off-shore drilling services ",
  },
  {
    id: 5,
    title: "Consultancy",
    image: image5,
    text: "With us, you get it right the first time",
  },
  {
    id: 6,
    title: "Solar Panel Installations",
    image: image6,
    text: "Need 100% solar powered capacity? We’ve got you covered.",
  },
];
export default ServicesData;
